import { PaymentOrder } from "@/types";

import { axios } from "../axios.instance";

export type GetOrderRequest = { orderId?: string };

export type GetOrderResponse = PaymentOrder;

export const getOrder = async (params: GetOrderRequest): Promise<GetOrderResponse> => {
  const { data } = await axios.get(`/payments/orders/${params.orderId}`);

  return data;
};
